
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/kids-play-area",
      function () {
        return require("private-next-pages/outlet/kids-play-area.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/kids-play-area"])
      });
    }
  